import { InterpolationWithTheme } from "@emotion/core";



export const interventionsDailyViewStyles: { [key: string]: InterpolationWithTheme<any> } = {
    table: {
        width: "100%"
    },
    divider: {
        borderTop: "1px solid #b6c7d6",
        width: "100%",
    },
    legendContainer: {
        display: "flex",
        justifyContent: "flex-end",
        background: "rgb(250, 251, 252)",
        padding: "5px 31px"
    },
    legend: {
        display: "flex",
        color: "rgb(76, 76, 76)",
        fontFamily: " BrandonTextWeb-Medium",
        fontSize: 12,
        fontWeight: 500,
        alignItems: 'center'
    },
    legendText: {
        margin: 5,
        marginTop: 6,
        textTransform: 'capitalize',
    },
    iterventionNameIcon: {
        marginRight: 5
    },
    iterventionNameText: {
        marginTop: 5,
        marginLeft: 24,
        color: "rgba(0, 0, 0, 0.87)",
        fontfamily: " BrandonTextWeb-Medium",
        fontSize: 14,
        fontWeight: 500
    },
    tableHeader: {
        color: "rgb(128, 128, 128)",
        fontFamily: "BrandonTextWeb-Medium",
        fontSize: 13,
        fontWeight: 500
    },
    tableCols: {
        padding: "10px 0px"
    },
    centerAlign: {
        textAlign: 'center'
    },
    rowsWrapper: {
        paddingRight: 17
    }

}